// 图表元素类型
export enum ChartElementType {
    AXIS_LABEL = 'axis-label',
    // 区分坐标轴为数值还是非数值坐标轴
    VALUE_AXIS_LABEL = 'value-axis-label',
    NOT_VALUE_AXIS_LABEL = 'not-value-axis-label',

    AXIS_TICK = 'axis-tick',
    AXIS_TITLE = 'axis-title',

    MAJOR_GRID = 'major-grid',  // 主网格线
    MINOR_GRID = 'minor-grid',  // 次网格线

    LEGEND = 'legend',
    TITLE = 'title',

    DATA_LABEL = 'data-label',

    GEOMETRY = 'geometry',
}

// 选中样式的种类
export enum SelectStyleType {
    BORDER,         // 显示边框
    ANCHOR,         // 显示"锚点圆圈"
    ENDS_ANCHOR,    // 显示"两端锚点"
}

// 图形类型，用于区分选中绘制形式，区分是fill还是stroke
export enum ShapeType {
    LINE = 'line',
    RECT = 'rect',
    AREA = 'area',
}

export interface IChartElement {
    id: string;
    groupId?: string;
    type: ChartElementType;
    rect: {
        height: number;
        width: number;
        top: number;
        left: number;
    };
    path: Array<Array<string|number>>;
    shapeType?: string;
    selectStyle?: SelectStyleType;
    extra?: any;
    selectEventData?: any; // 记录下select-change事件的eventData，用于主动更新选中态
    // 下面是自行收集元素的属性，完全切成使用select-event实现图表事件后删除
    direction?: string;
    // 图形类型，用于区分选中绘制形式，区分是fill还是stroke
    // 禁用单独选中。一般是group元素按需开启。比如grid虽然是group，但是不允许单独选中
    disableSingleSelect?: boolean;
    // 禁用成组选中
    disableGroupSelect?: boolean;
}

export type IChartElementGroup<T = IChartElement> = {
    group: T[];
    type: ChartElementType;
    id: string;
    selectEventData?: any;   // 记录下select-change事件的eventData，用于主动更新选中态
};

export type SelectedElement = IChartElement | IChartElementGroup;

export enum SpecialGeometryType {
    upDownBar = 'upDownBar',
    highLowLine = 'highLowLine',
    trendLine = 'trendLine',
}
